import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStepBack"><Path d="M7.81077 3.25011L6.75011 2.18945L2.68945 6.25011L6.75011 10.3108L7.81077 9.25011L5.56077 7.00011H14.2501C17.2877 7.00011 19.7501 9.46255 19.7501 12.5001C19.7501 15.5377 17.2877 18.0001 14.2501 18.0001H5.00011V19.5001H14.2501C18.1161 19.5001 21.2501 16.3661 21.2501 12.5001C21.2501 8.63412 18.1161 5.50011 14.2501 5.50011H5.56077L7.81077 3.25011Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStepBack;
